import { DaoService } from "./DaoService";

export default class DeploymentService extends DaoService {
    static getInstance() {
        return super.getInstance('deploiement');
    }

    getEnvironnements() {
        return DeploymentService.get(`${this.prefix}/environnements`);
    }

    trigger(cibles) {
        return DeploymentService.post(`${this.prefix}`, { cibles });
    }

    search(params = {}) {
        return DeploymentService.post(`${this.prefix}/search`, params);
    }

    getDetails(uid) {
        return DeploymentService.get(`${this.prefix}/${uid}`);
    }

    remove(uid) {
        return DeploymentService.delete(`${this.prefix}/${uid}`);
    }
}
